import { render, staticRenderFns } from "./CropDisplay.vue?vue&type=template&id=2ab2cd1a&scoped=true"
import script from "./CropDisplay.vue?vue&type=script&lang=js"
export * from "./CropDisplay.vue?vue&type=script&lang=js"
import style0 from "./CropDisplay.vue?vue&type=style&index=0&id=2ab2cd1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab2cd1a",
  null
  
)

export default component.exports